import React , { useState, useEffect }from 'react';
import { Link ,useHistory, useLocation,Redirect} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import './App.css';
import './App.less';
import  Routers  from './components/Router';
import { setLink,commonSelector } from './redux/commonReduxSlice';
import { useLastLocation } from 'react-router-last-location';

function App() {
  const location = useLocation()
  const history = useHistory()
  const lastLocation = useLastLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // const prelocation = lastLocation?lastLocation.pathname:null;
    // dispatch(setLink(prelocation,location.pathname));
  }, [])

  return (
    <Routers />
  );
}

export default App;
